var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"add-content-gallery"},[_c('custom-uploader',{attrs:{"value":_vm.entity.images,"multiple":true},on:{"update:value":function($event){return _vm.$set(_vm.entity, "images", $event)},"removeImage":_vm.removeImage,"input":_vm.addNewUploads}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }